module.exports = __webpack_public_path__ + "img/kelly-sikkema-hUuGUG9gdRg-unsplash.ea018e2b.jpg";